import type { Dispatch } from 'redux';
import { createActionFactory, HubPersona, Feature } from '../../shared';

export type MailComposeClickOrigin =
    | 'immersiveProfile'
    | 'commandBar'
    | 'privateDistributionList'
    | 'publicDistrbutionList'
    | 'multiPersonView'
    | 'inviteToGroupDialog';

export const mailComposeClickedAction = createActionFactory<{
    to: HubPersona[];
    origin: MailComposeClickOrigin;
    subject: string;
    body: string;
}>('MailComposeClickedAction', Feature.MailCompose, action => action.payload.origin);

export const mailComposePopoutOpenedAction = createActionFactory<void>(
    'MailComposePopoutOpenedAction',
    Feature.MailCompose
);

export const mailComposeClicked = (dispatch: Dispatch) => (
    to: HubPersona[],
    origin: MailComposeClickOrigin,
    subject?: string,
    body?: string
) => dispatch(mailComposeClickedAction({ to, origin, subject, body }));

export const mailComposePopoutOpened = (dispatch: Dispatch) => () =>
    dispatch(mailComposePopoutOpenedAction());
export type { Action } from '../../shared';
